/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable import/extensions */
import { call, put, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';
import { set } from 'utils/LocalStorageUtil';
import { apiCall, updateSwaggerManager } from 'api';
import Metrics from 'services/metrics';
import { LOAD_USER_REGISTER } from '../constants';
import {
  pendingUserRegister,
  errorUserRegister,
  successUserRegister,
  actionUserIsLoggedIn,
} from '../actions';
import { getUserRegister } from '../service';
import { GetRegion } from 'constants.js';
import qs from 'qs';

export function* sendRegister({ payload }) {
  yield put(pendingUserRegister());
  let metricsParams = {};

  try {
    const { login, ...params } = payload;

    const formData = new FormData();
    formData.append('email', params?.email);
     formData.append('password', params?.password);
     formData.append('accepterms', 1);


    const responseObject = yield call(getUserRegister, formData, params);

    if (responseObject.status === 200) {
      const { data: response } = responseObject?.data;

        const { session_stringvalue: HKS, region } = response;
        updateSwaggerManager(apiCall, { HKS, region });

        yield put(actionUserIsLoggedIn({ login, response }));
        const enable = true;
        set('selectProfile', { enable });
        // Set metrics
        const metricsLanding = {
          event: 'sign_up',
          method: 'correo electronico',
          parent_id: response?.parent_id,
          user_id: response?.user_id,
          user_type: 'registrado',
          country: GetRegion(),
        };
        const oldMetricsLading = {
          event: 'registro exitoso',
          eventCategory: 'landing',
          eventAction: 'registro',
          eventLabel: 'exitoso-correo',
        };
        Metrics.newEvent(metricsLanding);
        Metrics.newEvent(oldMetricsLading);
    } else if (responseObject.status >= 400 && responseObject.status <= 500) {
      const { data } = responseObject || {};
        yield put(successUserRegister(data.errors));
        // Set metrics
        const code = data?.errors?.[0]?.id;
        const eventLabel = `Registro Usuario y contraseña-WPLAY_API_${code}`;

        // Set metrics
        metricsParams = {
          event: 'Error',
          eventCategory: 'Errores',
          eventAction: 'Error',
          eventLabel,
        };
      
    }
    Metrics.newEvent(metricsParams);
  } catch (e) {
    let error = e;
    if(e?.status === 500){
      error = {
        data: {
          errors: [{
            code: e?.data?.errors?.[0]?.code || '_',
            detail: '_',
            source: '_'
        }]
        }
      }
    }
    yield put(errorUserRegister(error));
  }
}

export default function* registerSaga() {
  yield takeLatest(LOAD_USER_REGISTER.ACTION, sendRegister);
}
